import React from 'react';
import i18n from '../../i18n';
import Layout from '../../components/Layout';
import Toolbar from "../../components/Toolbar/Toolbar";
import {goBack} from "../../fn/navigation";
import CardContent from "@material-ui/core/CardContent/CardContent";
import Card from "@material-ui/core/Card/Card";
import PersonDetails from "../../components/Persons/PersonsDetails";
import Paper from "@material-ui/core/Paper/Paper";

const PersonsShow = ({person, personType, backLink}) => (
    <Layout>
        <Toolbar
            disableGutters
            title={person.first_name + ' ' + person.last_name}
            items={[
                {
                    icon: 'arrow_back',
                    text: i18n.get('contacts.back'),
                    href: backLink,
                    onClick: (event) => {
                        event.preventDefault();
                        goBack(backLink);
                    },
                    color: 'secondary',
                },
                {
                    icon: 'edit',
                    text: i18n.get('contacts.edit'),
                    href: `/persons/${personType}/${person.id}/edit`,
                }
            ]}
        />

                <PersonDetails person={person}/>
    </Layout>
);

export default PersonsShow;



// WEBPACK FOOTER //
// ./resources/assets/js/pages/qualifications/Show.jsx